import './App.css';
import FilterableProductTable from './components/FilterableProductTable';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <FilterableProductTable />
      </header>
    </div>
  );
}

export default App;
